module.exports = __webpack_public_path__ + "img/rankA.5ad00609.svg";